import PropTypes from 'prop-types';
import { useTimer } from '../hooks';
import { Time } from '../utils';
import {useStepsContext} from "../contexts/StepsContext";
import {useEffect, useState} from "preact/hooks";

const TIMER_IN_MINUTES = 5;

const time = new Date();
time.setSeconds(time.getSeconds() + Time.getSecondsFromMinutes(TIMER_IN_MINUTES));

var isActiveInstances = [false];
var instances = 0;

export default function SpotTimer({
    mobileOnly = false,
    desktopOnly = !mobileOnly,
    autoStart,
}) {
    const [showRefreshAnimation, setShowRefreshAnimation] = useState(false);
    const { getActiveStep } = useStepsContext();

    if (! getActiveStep().last && ! isActiveInstances[instances-1]) {
        return <></>
    }

    const onExpire = () => {
        setShowRefreshAnimation(true);
        setTimeout(() => {
            const newTime = new Date();
            newTime.setSeconds(newTime.getSeconds() + Time.getSecondsFromMinutes(TIMER_IN_MINUTES));
            restart(newTime);
            setShowRefreshAnimation(false);
        }, 2000);
    }

    const {
        seconds,
        minutes,
        restart
      } = useTimer({
        expiryTimestamp: time,
        autoStart,
        onExpire,
    });


    useEffect(() => {
        instances++;
        if (! isActiveInstances[instances-1]) {
            const newTime = new Date();
            newTime.setSeconds(newTime.getSeconds() + Time.getSecondsFromMinutes(TIMER_IN_MINUTES));
            restart(newTime)
            isActiveInstances[instances-1] = true;
        }

        return () => {
            instances--;
        }
    }, []);

    return (
        <>
            {showRefreshAnimation && (
                <div className="esc-ii-fixed esc-ii-z-50 esc-ii-h-full esc-ii-w-full esc-ii-bg-white/40 esc-ii-flex esc-ii-flex-col esc-ii-justify-center esc-ii-items-center">
                    <svg className={`esc-ii-animate-spin -esc-ii-ml-1 esc-ii-mr-3 esc-ii-h-5 esc-ii-w-5 esc-ii-text-black`} xmlns="http://www.w3.org/2000/svg" fill="none"
                         viewBox="0 0 24 24">
                        <circle className="esc-ii-opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path className="esc-ii-opacity-75" fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                </div>
            )}
            <div
                id="esc-ii-spot-timer"
                className={`${
                    desktopOnly ? 'esc-ii-hidden lg:esc-ii-flex' : 'esc-ii-flex'
                } esc-ii-justify-center esc-ii-font-montserrat esc-ii-items-center esc-ii-text-sm esc-ii-py-5 esc-ii-bg-yellow esc-ii-mb-4 lg:esc-ii-text-base${
                    mobileOnly && ' lg:esc-ii-hidden'
                }`}
            >
                <p className="esc-ii-font-montserrat esc-ii-text-xs lg:esc-ii-text-sm">
                    Your spot is reserved for <strong>{minutes > 0 ? `0${minutes}` : minutes} min {seconds} sec</strong>
                </p>
            </div>
        </>
    );
}

SpotTimer.propTypes = {
    mobileOnly: PropTypes.bool,
    desktopOnly: PropTypes.bool,
    autoStart: PropTypes.bool,
    onExpire: PropTypes.func
};
